function blogRedirect({ redirect, route }) {
  if (route.path === '/blog') {
    redirect(`${process.env.baseUrl}/`);
  }
}

export default blogRedirect;
